export const CREATE_JURISDICTION_REQUEST = 'CREATE_JURISDICTION_REQUEST';
export const CREATE_JURISDICTION_SUCCESS = 'CREATE_JURISDICTION_SUCCESS';
export const CREATE_JURISDICTION_FAILED = 'CREATE_JURISDICTION_FAILED';
